import { Sidebar_Portal } from "monica-alexandria";
import { config } from "../../../config";
import store from "../../../redux/store";
import { read_niffler_admin_path, read_niffler_leads_path } from "../../../router/niffler_routes";
import { Sidebar_Options } from "../sidebar/Sidebar_Options";
import {
    read_hide_admin_quest_navigation
} from "./sidebar_visibility";

/**
 * Renders the shared Doitforme sidebar shell with Niffler navigation inside it.
 */
export const Toolbar_ = (props) => {
    const routeLanguage = props?.routeLanguage || "en";
    const on_internal_navigate = props?.onInternalNavigate || (() => {});

    const go_to_boards = props?.onBoardsClick || (() => on_internal_navigate(`/${routeLanguage}/crm`));
    const go_to_export = props?.onExportClick || (() => on_internal_navigate(`/${routeLanguage}/crm/export`));
    const go_to_quest = props?.onQuestClick || ((questId) => on_internal_navigate(`/${routeLanguage}/crm/board/${questId}`));
    const go_to_leads = props?.onLeadsClick || (() => on_internal_navigate(read_niffler_leads_path(routeLanguage)));
    const go_to_brands = props?.onBrandsClick || (() => on_internal_navigate(read_niffler_admin_path(routeLanguage, "brands")));
    const go_to_sales = props?.onSalesClick || (() => on_internal_navigate(read_niffler_admin_path(routeLanguage, "sales")));
    const current_pathname = window?.location?.pathname || "";
    const userRoles = store.getState()?.user?.user?.roles || [];
    const hideAdminQuestNavigation = read_hide_admin_quest_navigation(current_pathname, userRoles);

    return (
        <Sidebar_Portal
            sidebar={props?.sidebar}
            onSidebar={props?.onSidebar}
            toolsTitle="TOOLS"
            adminTitle="ADMIN"
            admin
            showNetwork
            currentAppKey="niffler"
            routeLanguage={routeLanguage}
            baseUrls={config}
            onInternalNavigate={on_internal_navigate}
        >
            <Sidebar_Options
                sidebar={props?.sidebar}
                activeOption={props?.activeOption}
                activeQuestId={props?.activeQuestId}
                quests={props?.quests}
                archivedQuests={props?.archivedQuests}
                onBoardsClick={go_to_boards}
                onExportClick={go_to_export}
                onQuestClick={go_to_quest}
                onLeadsClick={go_to_leads}
                onBrandsClick={go_to_brands}
                onSalesClick={go_to_sales}
                hideAdminQuestNavigation={hideAdminQuestNavigation}
            />
        </Sidebar_Portal>
    );
};
